const useLogic = () => {
  const navItems = [
    { label: "Home", path: "/" },
    { label: "Features", path: "/features" },
    { label: "Contact", path: "/contact" },
  ];

  return { navItems };
};

export default useLogic;
